import React from 'react'
import { SupplierDetailFormAdminStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  InputTextarea,
  Modal,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { Form, Formik } from 'formik'
import { supplierManagementController } from '../../apiService'
import { findId } from '../../helpers/functions/findIdUrl'
import { dateMonDayYearTime } from '../../helpers/functions/format'

export class SupplierDetailFormAdminRejectContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsCountry: [{ value: 'Thailand', label: 'Thailand' }],
      isEditPageState: true,
      isWaitingForActivateState: false,
      isWaitingForApprovalState: false,
      isActive: true,
      isRequested: true,
      modals: [
        // { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false },
        { name: 'rejectSupplier', isOpen: false },
      ],
      detailFrom: {
        taxId: '',
        companyName: '',
        regAddress: '',
        regCountry: '',
        contactAddress: '',
        contactCountry: '',
        fullName: '',
        email: '',
        phone: '',
        approveStatus: '',
        active: false,
        updateBy: '',
        updateDate: '',
      },
    }
  }

  componentDidMount() {
    this.fetchSupplierByID()
  }

  initDetailForm = values => {
    if (values) {
      const DEFAUL_VALUE = 0
      this.setState({
        detailFrom: {
          taxId: values.tax_id || DEFAUL_VALUE,
          companyName: values.company_name || '',
          regAddress: values.regis_address || '',
          regCountry: values.regis_country || '',
          contactAddress: values.contact_address || DEFAUL_VALUE,
          contactCountry: values.contact_country || DEFAUL_VALUE,
          fullName: values.supplier_full_name || DEFAUL_VALUE,
          email: values.supplier_email || '',
          phone: values.supplier_phone || '',
          approveStatus: values.approve_status || DEFAUL_VALUE,
          active: values.status || DEFAUL_VALUE,
          updateBy: values.update_by || DEFAUL_VALUE,
          updateDate: values.update_date || DEFAUL_VALUE,
        },
      })
    }
  }

  fetchSupplierByID = async () => {
    try {
      const id = findId(window.location.pathname)
      if (!id) return
      const res = await supplierManagementController().getByID(id)
      if (res) {
        this.initDetailForm(res)
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  onClickCancel = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
  }

  handleChange = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  render() {
    const { optionsCountry } = this.state

    return (
      <React.Fragment>
        <SupplierDetailFormAdminStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_supplier_form"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_supplier_form" className="title">
                  Supplier Management
                </Section>

                <Section
                  id="page_breadcrumb_supplier_form"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button
                    onClick={() => {
                      this.props.history.push(
                        ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK
                      )
                    }}
                    className="breadcrumb"
                  >
                    <span>Supplier Management</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>View Supplier</span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Formik
            enableReinitialize
            initialValues={this.state.detailFrom}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ handleBlur, handleChange, handleSubmit, values }) => {
              return (
                <Section className="main-content form">
                  <Section className="content-body">
                    <Section className="form-wrapper">
                      <Section className="form-group-title">
                        View Supplier
                      </Section>
                      <Form onSubmit={handleSubmit}>
                        <Section className="form-group">
                          <label>Tax ID</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                disabled={true}
                                type="text"
                                value={values.taxId}
                                onChange={handleChange('taxId')}
                                onBlur={handleBlur('taxId')}
                              />
                            </Section>

                            <Section className="message">error</Section>
                          </Section>
                        </Section>
                        <Section className="form-group">
                          <label>Company Name</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                disabled={true}
                                value={values.companyName}
                                onChange={handleChange('companyName')}
                                onBlur={handleBlur('companyName')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-row">
                          <Section className="form-col col-6">
                            <Section className="form-group-header">
                              Registered Address
                            </Section>

                            <Section className="form-group">
                              <label>Address</label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  <InputTextarea
                                    disabled={true}
                                    value={values.regAddress}
                                    onChange={handleChange('regAddress')}
                                    onBlur={handleBlur('regAddress')}
                                  />
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section>

                            <Section className="form-group">
                              <label>Country</label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  <SelectBox
                                    id="active_status_filter"
                                    defaultValue={optionsCountry[0]}
                                    options={optionsCountry}
                                    isSearchable={false}
                                    isClearable={false}
                                    isDisabled={true}
                                  />
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section>
                          </Section>

                          <Section className="form-col col-6">
                            <Section className="form-group-header grid-to-label">
                              Contact Address
                            </Section>

                            <Section className="form-group">
                              <label>Address</label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  <InputTextarea
                                    disabled={true}
                                    value={values.contactAddress}
                                    onChange={handleChange('contactAddress')}
                                    onBlur={handleBlur('contactAddress')}
                                  />
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section>

                            <Section className="form-group">
                              <label>Country</label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  <SelectBox
                                    id="active_status_filter"
                                    defaultValue={optionsCountry[0]}
                                    options={optionsCountry}
                                    isSearchable={false}
                                    isClearable={false}
                                    isDisabled={true}
                                  />
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section>
                          </Section>
                        </Section>

                        <Section className="form-group-header">
                          Contact Person
                        </Section>

                        <Section className="form-group">
                          <label>Full name</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                disabled={true}
                                type="text"
                                value={values.fullName}
                                onChange={handleChange('fullName')}
                                onBlur={handleBlur('fullName')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label>Email</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                disabled={true}
                                type="text"
                                value={values.email}
                                onChange={handleChange('email')}
                                onBlur={handleBlur('email')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label>Phone</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                disabled={true}
                                type="text"
                                value={values.phone}
                                onChange={handleChange('phone')}
                                onBlur={handleBlur('phone')}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-group approve-status">
                          <label>Approve Status</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              {/* approved / rejected */}
                              <span className="rejected">
                                Rejected on {dateMonDayYearTime()} by{' '}
                                {values.updateBy}
                              </span>
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>
                      </Form>
                    </Section>

                    <Section className="form-actions">
                      <Button
                        className="theme-border-gray"
                        onClick={() => this.onClickCancel()}
                      >
                        Cancel
                      </Button>
                    </Section>
                  </Section>
                </Section>
              )
            }}
          </Formik>
        </SupplierDetailFormAdminStyle>
      </React.Fragment>
    )
  }
}
